import {
  configSelector,
  EdgeConfig,
  systemSelector,
} from '@Utils/plarium/edgets-common/lib/configModule/edgeConfigModule';
import { userSpecificSelector } from '@Utils/plarium/edgets-common/lib/configModule/edgeUserSpecificModule';
import { get, reduce } from '@Utils/facade/lodash';
import { RootState } from '@Utils/core/redux';
import { createSelector } from 'reselect';
import { Server } from './types';

const fromConfigSelector =
  (selector: (state: any) => any) =>
  <T>(path: string, defaultValue: T): ((state: any) => T) =>
  (state: any) =>
    get(selector(state), path, defaultValue) as T;

const fromConfig = fromConfigSelector(configSelector);
const fromSystem = fromConfigSelector(systemSelector);

export const isGamePageSelector = fromConfig('globals.analytics.isGamePage', false);

interface ServerWithoutOptions extends Server {
  template_options: Server['options'];
}
// @todo move this data to global widget
// Fix template options
export const serversSelector = createSelector(
  fromConfig('globals.servers', [] as ServerWithoutOptions[]),
  (servers: ServerWithoutOptions[]) => {
    const fixedServers = servers.map((s) => ({
      strings: s.strings,
      images: reduce(
        s.images,
        (m, img, key) => {
          return {
            ...m,
            [key]: fixImage(img),
          };
        },
        {} as Server['images'],
      ),
      links: s.links,
      options: s.template_options,
    })) as Server[];
    return fixedServers;
  },
);

function fixImage(img: { href?: string; src?: string }): { src?: string } {
  return {
    ...img,
    src: img.href || img.src,
  };
}

export const gameNameSelector = fromConfig('globals.analytics.area', null as null | string);
export const socialAuthSelector = fromConfig('globals.auth', {} as EdgeConfig['globals']['auth']);

export const chatLocalizationBaseUrlSelector = fromSystem('chatLocalizationBaseUrl', '');
export const hubUrlSelector = fromSystem('hubUrl', '');
export const homePageUrlSelector = fromSystem('homePageUrl', '');
export const apiUrlSelector = fromSystem('apiUrl', '/');
export const systemApiUrlSelector = fromSystem('systemApiUrl', '/');
export const requestUrlSelector = fromConfig('globals.requestUrl', '');

// User Specific based selectors
export const userSpecificTokenSelector = (state: RootState) =>
  userSpecificSelector(state).accessToken;
export const userSpecificIdSelector = (state: RootState) => userSpecificSelector(state).id;
export const userIdSelector = createSelector(
  userSpecificSelector,
  (userSpecific) => userSpecific.id || 0,
);
export const isUserLoggedInSelector = createSelector(userSpecificTokenSelector, (token) => !!token);
